var mod, withNoStyleOption, withNoTypeOption;

mod = angular.module('gym.calendar', ['ui.calendar']);

withNoTypeOption = function(types) {
  return types.concat({
    name: 'No type set',
    id: -1,
    active: true
  });
};

withNoStyleOption = function(types) {
  return types.concat({
    name: 'No style set',
    id: -1
  });
};

mod.factory("CalendarService", ["$modal", "$state", "$window", "loadingAnimation", "CalendarLastVisitedViewService", "DeleteEventScheduleService", "flash", function($modal, $state, $window, loadingAnimation, CalendarLastVisitedViewService, DeleteEventScheduleService, flash) {
  return {
    deleteEvent: function(scope, event, removeListeners) {
      var base, deleteEvent, parentScope, ref, repeatingEvent, trainerModal;
      if (event.event_schedule_id || ((ref = event.attributes) != null ? ref.event_schedule_id : void 0)) {
        DeleteEventScheduleService.delete(event, removeListeners);
        return;
      }
      (base = scope.event).edit_type || (base.edit_type = 'single');
      repeatingEvent = !!scope.event.repeats || !!scope.event.repeat_until || scope.event.infinite;
      deleteEvent = function() {
        if (event.delete) {
          return event.delete();
        } else {
          return event.remove();
        }
      };
      scope.performDelete = function(modalInstance) {
        loadingAnimation.show();
        return deleteEvent().then(function() {
          if (modalInstance != null) {
            modalInstance.close();
          }
          $state.go(CalendarLastVisitedViewService.get());
          return loadingAnimation.hide();
        }, function() {
          flash.error = 'Something went wrong, please try again later';
          return loadingAnimation.hide();
        });
      };
      if (!repeatingEvent) {
        if ($window.confirm("Are you sure?")) {
          return scope.performDelete();
        }
      } else {
        parentScope = scope;
        return trainerModal = $modal.open({
          template: require('templates/gyms/calendar/events/delete_event_modal.html.slim'),
          scope: scope,
          controller: 'DeleteEventModalCtrl'
        });
      }
    }
  };
}]);

mod.config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.calendar', {
    url: '/calendar?instructor_id&location_id&event_type_id&style_id&view&no_kiosk_events&notice&from&event_id',
    template: require('templates/gyms/calendar/calendar.html.slim'),
    controller: 'CalendarCtrl',
    reloadOnSearch: false,
    resolve: {
      locations: ["Locations", function(Locations) {
        return Locations.getList({
          count: 1000
        });
      }],
      selectedLocation: ["gym", "locations", "DefaultCalendarLocationService", function(gym, locations, DefaultCalendarLocationService) {
        return DefaultCalendarLocationService.get(gym, locations);
      }],
      eventTypes: ["EventTypes", function(EventTypes) {
        return EventTypes.getList({
          count: 1000
        }).then(function(response) {
          return withNoTypeOption(response);
        });
      }],
      styles: ["GradingStyles", function(GradingStyles) {
        return GradingStyles.getList({
          count: 1000,
          slim: 1
        }).then(function(response) {
          return withNoStyleOption(response);
        });
      }]
    }
  }).state('gym.trainers', {
    url: '/calendar/trainers',
    template: require('templates/gyms/trainers/trainers.html.slim'),
    controller: 'TrainersCtrl',
    resolve: {
      locations: ["Locations", function(Locations) {
        return Locations.getList({
          count: 1000
        });
      }],
      selectedLocation: ["gym", "locations", "DefaultCalendarLocationService", function(gym, locations, DefaultCalendarLocationService) {
        return DefaultCalendarLocationService.get(gym, locations);
      }],
      eventTypes: ["EventTypes", function(EventTypes) {
        return EventTypes.getList({
          count: 1000
        }).then(function(response) {
          return withNoTypeOption(response);
        });
      }],
      styles: ["GradingStyles", function(GradingStyles) {
        return GradingStyles.getList({
          count: 1000,
          slim: 1
        }).then(function(response) {
          return withNoStyleOption(response);
        });
      }]
    }
  }).state('gym.weeklyTrainers', {
    url: '/calendar/trainers/weekly',
    template: require('templates/gyms/trainers/weeklyTrainers.html.slim'),
    controller: 'WeeklyTrainersCtrl',
    resolve: {
      locations: ["Locations", function(Locations) {
        return Locations.getList({
          count: 1000
        });
      }],
      selectedLocation: ["gym", "locations", "DefaultCalendarLocationService", function(gym, locations, DefaultCalendarLocationService) {
        return DefaultCalendarLocationService.get(gym, locations);
      }],
      eventTypes: ["EventTypes", function(EventTypes) {
        return EventTypes.getList({
          count: 1000
        }).then(function(response) {
          return withNoTypeOption(response);
        });
      }],
      styles: ["GradingStyles", function(GradingStyles) {
        return GradingStyles.getList({
          count: 1000,
          slim: 1
        }).then(function(response) {
          return withNoStyleOption(response);
        });
      }]
    }
  }).state('gym.weeklyAgenda', {
    url: '/calendar/weekly_agenda',
    template: require('templates/gyms/calendar/weekly_agenda.html.slim'),
    controller: 'WeeklyAgendaCtrl',
    resolve: {
      locations: ["Locations", function(Locations) {
        return Locations.getList({
          count: 1000
        });
      }],
      isFreeTrials: function() {
        return false;
      },
      selectedLocation: ["gym", "locations", "DefaultCalendarLocationService", function(gym, locations, DefaultCalendarLocationService) {
        return DefaultCalendarLocationService.get(gym, locations);
      }],
      eventTypes: ["EventTypes", function(EventTypes) {
        return EventTypes.getList({
          count: 1000
        }).then(function(response) {
          return withNoTypeOption(response);
        });
      }],
      styles: ["GradingStyles", function(GradingStyles) {
        return GradingStyles.getList({
          count: 1000,
          slim: 1
        }).then(function(response) {
          return withNoStyleOption(response);
        });
      }]
    }
  }).state('gym.freeTrials', {
    url: '/calendar/free_trials',
    template: require('templates/gyms/calendar/weekly_agenda.html.slim'),
    controller: 'WeeklyAgendaCtrl',
    resolve: {
      locations: ["Locations", function(Locations) {
        return Locations.getList({
          count: 1000
        });
      }],
      isFreeTrials: function() {
        return true;
      },
      selectedLocation: ["gym", "locations", "DefaultCalendarLocationService", function(gym, locations, DefaultCalendarLocationService) {
        return DefaultCalendarLocationService.get(gym, locations);
      }],
      eventTypes: ["EventTypes", function(EventTypes) {
        return EventTypes.getList({
          count: 1000
        }).then(function(response) {
          return withNoTypeOption(response);
        });
      }],
      styles: ["GradingStyles", function(GradingStyles) {
        return GradingStyles.getList({
          count: 1000,
          slim: 1
        }).then(function(response) {
          return withNoStyleOption(response);
        });
      }]
    }
  }).state('gym.bulk_enrol', {
    url: '/calendar/events/:event_id/report_bulk_bookings/new?report_id?waitlist?booking?from',
    template: require('templates/gyms/calendar/events/bulk_enrol.html.slim')
  }).state('gym.cancelEvent', {
    url: '/calendar/event_cancellations/new?eventId',
    template: require('templates/gyms/calendar/events/cancel_event.html.slim'),
    controller: 'CancelEventCtrl',
    resolve: {
      event: ["$stateParams", "Calendar", "$q", "$state", "$window", function($stateParams, Calendar, $q, $state, $window) {
        return Calendar.one('events', $stateParams.eventId).get().then(function(data) {
          return data;
        }, function(response) {
          var url;
          if (response.status === 404) {
            url = $state.href('gym.calendar', {
              gymId: $stateParams.gymId,
              notice: 'This event has been removed.'
            });
            $window.open(url, '_self');
            return $q.reject();
          }
        });
      }]
    }
  }).state('gym.onlineMeetings', {
    url: '/calendar/online_meetings',
    template: require('templates/gyms/calendar/online_meetings.html.slim'),
    controller: 'OnlineMeetingsCtrl',
    resolve: {
      locations: ["Locations", function(Locations) {
        return Locations.getList({
          count: 1000
        });
      }],
      selectedLocation: ["gym", "locations", "DefaultCalendarLocationService", function(gym, locations, DefaultCalendarLocationService) {
        return DefaultCalendarLocationService.get(gym, locations);
      }],
      eventTypes: ["EventTypes", function(EventTypes) {
        return EventTypes.getList({
          count: 1000
        }).then(function(response) {
          return withNoTypeOption(response);
        });
      }],
      styles: ["GradingStyles", function(GradingStyles) {
        return GradingStyles.getList({
          count: 1000,
          slim: 1
        }).then(function(response) {
          return withNoStyleOption(response);
        });
      }]
    }
  }).state('gym.showEvent', {
    url: '/calendar/events/:eventId?location_id&instructor_id',
    templateUrl: function(params) {
      return `/gyms/${params.gymId}/calendar/events/show.template`;
    },
    controller: 'ShowEventCtrl',
    resolve: {
      event: ["gym", "EventOccurrance", "$stateParams", "$q", "$state", "$rootScope", "$window", "$location", function(gym, EventOccurrance, $stateParams, $q, $state, $rootScope, $window, $location) {
        var url;
        url = gym.link('events') + `/${$stateParams.eventId}`;
        return EventOccurrance.load(url).then(function(data) {
          var event;
          if (data.event_schedule_id) {
            url = $state.href('gym.editEvent', {
              eventId: $stateParams.eventId,
              gymId: $stateParams.gymId
            });
            if ($rootScope.gym) {
              $location.path(url).replace();
              $state.go('gym.editEvent', {
                eventId: $stateParams.eventId
              });
            } else {
              $window.open(url, '_self');
            }
            return $q.reject();
          }
          return event = new EventOccurrance(data, {
            parent: gym,
            collection: gym.events()
          }, true);
        }, function(response) {
          if (response.status === 404) {
            url = $state.href('gym.calendar', {
              gymId: $stateParams.gymId,
              notice: 'This event has been removed.'
            });
            $window.open(url, '_self');
            return $q.reject();
          }
        });
      }],
      forms: ["MemberForms", function(MemberForms) {
        return MemberForms.getList();
      }],
      classroom: ["gym", "Classroom", "event", function(gym, Classroom, event) {
        var collection, room, roomId, url;
        roomId = event.attributes.classroom_id;
        collection = gym.classrooms();
        room = collection.find(roomId);
        if (room != null) {
          return room;
        }
        url = gym.link('classrooms') + `/${roomId}`;
        return Classroom.load(url).then(function(data) {
          room = collection.build(room);
          room.load(data);
          return room;
        });
      }],
      styles: ["GradingStyles", function(GradingStyles) {
        return GradingStyles.getList({
          count: 1000,
          slim: 1
        });
      }],
      eventTypes: ["EventTypes", function(EventTypes) {
        return EventTypes.getList({
          count: 1000
        });
      }]
    }
  }).state('gym.editEvent', {
    url: '/calendar/events/:eventId/edit?location_id&instructor_id&editSection',
    template: require('templates/gyms/calendar/events/edit_event_container.html.slim'),
    controller: 'EditEventContainerCtrl',
    resolve: {
      event: ["$stateParams", "Calendar", "$q", "$state", "$window", function($stateParams, Calendar, $q, $state, $window) {
        return Calendar.one('events', $stateParams.eventId).get().then(function(data) {
          return data;
        }, function(response) {
          var url;
          if (response.status === 404) {
            url = $state.href('gym.calendar', {
              gymId: $stateParams.gymId,
              notice: 'This event has been removed.'
            });
            $window.open(url, '_self');
            return $q.reject();
          }
        });
      }],
      classrooms: ["gym", "Classroom", function(gym, Classroom) {
        var collection;
        collection = gym.classrooms();
        return Classroom.load(gym.link('classrooms')).then(function(classrooms) {
          var classroom, i, instance, len;
          for (i = 0, len = classrooms.length; i < len; i++) {
            classroom = classrooms[i];
            if (!collection.find(classroom.id)) {
              instance = collection.build();
              instance.load(classroom);
            }
          }
          return collection;
        });
      }],
      styles: ["GradingStyles", function(GradingStyles) {
        return GradingStyles.getList({
          count: 1000,
          slim: 1
        });
      }]
    }
  }).state('gym.eventPrintQrCode', {
    url: '/calendar/events/:eventId/qr_code',
    template: require('templates/gyms/calendar/events/qr_code.html.slim'),
    reloadOnSearch: false
  });
}]);

mod.controller('DeleteEventModalCtrl', [
  '$scope',
  '$modalInstance',
  function(scope,
  modalInstance) {
    scope.event = scope.$parent.event;
    scope.ok = function() {
      return scope.$parent.performDelete(modalInstance);
    };
    return scope.cancel = function() {
      return modalInstance.dismiss('cancel');
    };
  }
]);
